require ('./admin_review.less');
import PreLoader from 'preloader';

window.bitrixAdminShowReviewTree = function (threadID) {
    const loader = new PreLoader();
    loader.show();
    $.ajax({
        url: '/ajax/component/maximaster:widget.review.tree/admin/',
        data: {
            THREAD_ID : threadID
        },
        success: function (result) {
            loader.hide(0);
            const popup = new BX.CDialog({
                'title': 'Дерево комментариев',
                'content': result.html,
                'draggable': true,
                'resizable': true,
                'buttons': [BX.CDialog.btnClose]
            });
            popup.Show();
        }
    });
};


// WEBPACK FOOTER //
// ./blocks/admin_review/admin_review.js